import React, { useMemo, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { API_CONFIG } from '../config/api';

const NewDioForm = () => {
    const [kataloskiBroj, setKataloskiBroj] = useState('');
    const [nazivDijela, setNazivDijela] = useState('');
    const [dostupnaKolicina, setDostupnaKolicina] = useState('');
    const [minimalnaKolicina, setMinimalnaKolicina] = useState('0');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState('');
    // const navigate = useNavigate();
    const currentUser = useMemo(() => { try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; } }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess('');

        const token = localStorage.getItem('token');
        if (!token) {
            setError('Autentikacija neuspjela. Molimo prijavite se ponovno.');
            return;
        }

        try {
            const response = await fetch(API_CONFIG.ENDPOINTS.DIJELOVI, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    kataloski_broj: kataloskiBroj,
                    naziv_dijela: nazivDijela,
                    dostupna_kolicina: parseInt(dostupnaKolicina, 10),
                    minimalna_kolicina: minimalnaKolicina === '' ? 0 : parseInt(minimalnaKolicina, 10),
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Greška prilikom kreiranja dijela.');
            }

            setSuccess('Dio uspješno dodan!');
            setKataloskiBroj('');
            setNazivDijela('');
            setDostupnaKolicina('');
            setMinimalnaKolicina('0');
            // Optional: Redirect after a short delay
            // setTimeout(() => navigate('/dashboard'), 2000);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="max-w-md mx-auto">
            <div className="p-8 bg-white rounded-lg shadow-sm border border-gray-200 w-full">
                <div className="flex items-center justify-center mb-6">
                    <FontAwesomeIcon icon={faPlusCircle} className="text-blue-500 text-3xl mr-3" />
                    <h2 className="text-2xl font-bold text-gray-800">Novi Dio</h2>
                </div>
                {error && <div className="p-3 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">{error}</div>}
                {success && <div className="p-3 mb-4 text-sm text-green-700 bg-green-100 rounded-lg">{success}</div>}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="kataloskiBroj" className="block text-sm font-medium text-gray-700">Kataloški broj</label>
                        <input
                            type="text"
                            id="kataloskiBroj"
                            value={kataloskiBroj}
                            onChange={(e) => setKataloskiBroj(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="nazivDijela" className="block text-sm font-medium text-gray-700">Naziv dijela</label>
                        <input
                            type="text"
                            id="nazivDijela"
                            value={nazivDijela}
                            onChange={(e) => setNazivDijela(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="dostupnaKolicina" className="block text-sm font-medium text-gray-700">Dostupna količina</label>
                        <input
                            type="number"
                            id="dostupnaKolicina"
                            value={dostupnaKolicina}
                            onChange={(e) => setDostupnaKolicina(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                    {currentUser?.role === 'admin' && (
                        <div>
                            <label htmlFor="minimalnaKolicina" className="block text-sm font-medium text-gray-700">Minimalna količina (za upozorenje)</label>
                            <input
                                type="number"
                                id="minimalnaKolicina"
                                value={minimalnaKolicina}
                                min="0"
                                onChange={(e) => setMinimalnaKolicina(e.target.value)}
                                className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                    )}
                    <button
                        type="submit"
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Dodaj dio
                    </button>
                </form>
            </div>
        </div>
    );
};

export default NewDioForm;
